// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"7e224768","453":"cc9d0bf6","482":"9df1b591","789":"872ad8ac","806":"09561b1a","825":"2b44f737","888":"24d1792c","958":"ae0723da"}[chunkId] + ".chunk.js";
};